import * as React from "react";
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);
export class HorizontalSelections extends React.Component {
    constructor() {
        super(...arguments);
        this.list = React.createRef();
    }
    componentDidUpdate(prevProps) {
        if (React.Children.count(prevProps.children) !== React.Children.count(this.props.children) &&
            this.list.current &&
            this.list.current.children.length > 2) {
            gsap.to(this.list.current, {
                scrollTo: {
                    x: "max"
                },
                duration: 0.3
            });
        }
    }
    render() {
        return (React.createElement("div", { className: "rj-yourbet__selection-list", "data-uat": "id-bets-selections", ref: this.list }, this.props.children));
    }
}
//# sourceMappingURL=HorizontalSelections.js.map